// extracted by mini-css-extract-plugin
export default {"container":"Vaa-z","productName":"Waa-z","price":"Xaa-z","dimensions":"Yaa-z"};